import { GameWinLineCelebrationProperties } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/properties/GameWinLineCelebrationProperties";
export class WinLineCelebrationPortraitProperties extends GameWinLineCelebrationProperties {
    constructor() {
        super();
        this.position.set(8, 357);
    }
}
//# sourceMappingURL=WinLineCelebrationPortraitProperties.js.map